<template>
  <b-container id="oauth">

    <b-overlay :show="loading" variant="white" opacity="0.7">

    </b-overlay>

  </b-container>
</template>

<script>
// @ is an alias to /src

import store from "@/store/";
import {SETUP_FROM_DATA} from "@/store/consts";

export default {
  name: "OAuth",
  props: ["provider", "code"],
  data() {
    return {
      form: {
        email: "",
        password: "",
        remember: false,
      },
      loading: false,
      root: "root",
    };
  },

  computed: {
    isRoot() {
      return this.form.email === "root";
    },
  },
  mounted() {
    let url = "/api/oauth/";

    if (this.provider == "github") {
      url += 'github?code=' + this.code;
      this.provider_name = 'GitHub';
    } else if (this.provider == "linkedin") {
      url += 'linkedin?code=' + this.code + '&state=' + this.state;
      this.provider_name = 'LinkedIn';
    } else {
      // Не форматированное имя
      this.provider_name = this.provider;
      console.log("Unknown OAuth provider: " + this.provider + ", code: " + this.code);
    }

    this.$get(url, true)
        .then((result) => {
          store.dispatch(SETUP_FROM_DATA, result.user);

          if (store.getters.isComplete()) {
            if (this.$route.params.nextUrl) {
              this.$router.push(this.$route.params.nextUrl);
            } else {
              if (store.getters.isAdmin) {
                this.$router.push("/admin");
              } else {
                this.$router.push("/dashboard");
              }
            }
          }
        })
        .catch(e => {
          console.log("OAuth failed with the following error: ", e);
          this.$router.replace({
            name: "sign-in",
            params: {provider: this.provider_name, code: e.code, message: e.message}
          });
        });
  },
  methods: {},
};
</script>
